<div class="gallery-component" *transloco="let t">
  <div>
    <ion-img
      *ngFor="let image of visibleImages; let i = index"
      class="picture"
      [src]="image.thumb || image.url"
      (click)="handleImageClick(i)"
    ></ion-img>
  </div>
  <ion-text
    color="primary"
    (click)="showMore()"
    *ngIf="images && images.length > showingCount"
    ><span>{{t('common.showMore')}}</span></ion-text>
</div>
